/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { makeStyles } from "@material-ui/core/styles/";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Loading from "../../pages/home/components/Loading";
import { Portlet, PortletBody } from "../../partials/content/Portlet";
import { StyledTableContent } from "./styles";
import "./styles.scss";
import { Tabs, Tab, AppBar, Box, Typography } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { PageHeader } from "../../pages/admin/components/PageHeader/PageHeader";
import { globalColors } from "../../../_metronic/_assets/sass/custom/globalColors";

import store from "../../store/store";
import { USER_ROLES } from "../../enum/UserRoles";

const TabsParametrizacao = (props) => {
  const titles = props.titles;
  const adminTabs = props.adminTabs;

  const [isLoading] = useState("");
  const [isLoadingExport] = useState("");
  const [contents] = useState(props.contents);
  const [value, setValue] = useState(0);

  const { auth } = store.getState();
  const isAdmin = [USER_ROLES.ADMIN].includes(auth?.user?.role);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box classes={{ root: "content" }} p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  const styles = {
    root: {
      fontFamily: "Open Sans",
      maxHeight: "fit-content",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      minHeight: "75vh",
      borderRadius: "4px",
      boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
    },
    paper: {
      width: "100%",
      flex: "1",
    },
    tab: {
      selected: {
        backgroundColor: `${globalColors.colorWhite} !important`,
        color: globalColors.primaryColor5,
        boxShadow: "5px 5px 10px rgba(0,0,0,0.1)",
      },
      textColorInherit: {
        color: globalColors.primaryColor5,
      },
      root: {
        boxShadow: "5px 5px 10px rgba(0,0,0,0.1)",
        height: "65px",
        marginBotton: "-5px",
        padding: "0 !important",
        backgroundColor: `${globalColors.colorWhite}`,
      },
    },
  };
  const useStyles = makeStyles(() => {
    return {
      ...styles,
    };
  });

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    if (props.rememberTab !== false) sessionStorage.setItem("lastTab", newValue);
    setValue(newValue);
    if (typeof props.onTabChange === "function") props.onTabChange(newValue);
  };

  useEffect(() => {
    const allowed = (index) => Number.isInteger(index) && index >= 0 && index < titles.length && (!adminTabs.index.includes(index) || isAdmin);
    const lastTab = sessionStorage.getItem("lastTab");
    if (allowed(props.initialTab)) setValue(props.initialTab);
    else if (props.rememberTab !== false && lastTab !== null && allowed(Number(lastTab))) setValue(Number(lastTab));
    else setValue(0);
  }, [props.initialTab, isAdmin]);

  return (
    <div
      className={`col-xl-12 xv-parameter-tabs ${props.className || ""}`}
      style={{
        minHeight: "max-content",
        marginTop: "0px",
        display: "flex",
        justifyContent: "center",
        backgroundColor: globalColors.backgroundColor5,
      }}
    >
      <StyledTableContent
        className="xv-parameter-tabs__surface"
        style={{ maxHeight: "fit-content", padding: "0 1rem" }}
      >
        <Loading isLoading={isLoading || isLoadingExport} />
        <Portlet
          fluidHeight={true}
          className="xv-parameter-tabs__portlet"
          style={{ backgroundColor: "#F9F7F6" }}
        >
          <div className="xv-parameter-tabs__duplicate-title">
            <PageHeader
              className="xv-parameter-tabs__header"
              icon={props.icon}
              title={props.title}
            />
          </div>

            <PortletBody
              className="xv-parameter-tabs__body"
            style={{
              marginTop: "2rem",
              boxShadow: "0, 2px 0px 2px rgba(0, 0, 0, 0.14), 0, 0",
              backgroundColor: globalColors.colorWhite,
            }}
          >
            <Container
              style={{
                margin: 0,
                padding: 0,
                width: "100%",
                boxShadow:
                  "-1px 2px 5px 0px rgba(0,0,0,0.3), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12)",
              }}
            >
              <AppBar
                className="xv-parameter-tabs__bar"
                position="static"
                style={{
                  margin: 0,
                  padding: 0,
                  boxShadow: "none",
                }}
              >
                <Tabs
                  className="xv-parameter-tabs__tabs"
                  variant="scrollable"
                  scrollButtons="auto"
                  value={value}
                  onChange={handleChange}
                  aria-label=""
                  style={{
                    margin: 0,
                    padding: 0,
                    boxShadow: "none",
                    backgroundColor: `${globalColors.colorWhite}`,
                  }}
                  sx={{
                    "& .MuiTabs-indicator": {
                      backgroundColor: globalColors.primaryColor5,
                    },
                    "& .MuiTabs-flexContainer": {
                      justifyContent: "space-between",
                    },
                  }}
                >
                  {titles &&
                    titles.map(
                      (title, i) =>
                        (!adminTabs.index.includes(i) ||
                          (adminTabs.index.includes(i) && isAdmin)) && (
                          <Tab
                            classes={{
                              selected: "selected",
                              root: "root",
                              textColorInherit: "textColorInherit",
                            }}
                            label={title}
                            {...a11yProps(i)}
                          />
                        )
                    )}
                </Tabs>
              </AppBar>
            </Container>
            {contents &&
              contents.map(
                (content, i) =>
                  (!adminTabs.index.includes(i) ||
                    (adminTabs.index.includes(i) && isAdmin)) && (
                    <TabPanel
                      value={value}
                      index={i}
                      style={{
                        margin: 0,
                        padding: 0,
                        boxShadow: "none",
                      }}
                      sx={{
                        "& .MuiBox-root": {
                          padding: 0,
                          margin: 0,
                          boxShadow: "none",
                        },
                      }}
                    >
                      {content}
                    </TabPanel>
                  )
              )}
          </PortletBody>
        </Portlet>
      </StyledTableContent>
    </div>
  );
};

export default TabsParametrizacao;
